import { HubsSettingClient } from 'frontend-preferences-client';
export const hubsSettingClient = HubsSettingClient.forCaller('framework-data-table');